/**
 * Unregister service worker to prevent it from intercepting external image requests
 * This allows the browser's native cache (respecting Cache-Control headers) to handle images
 */

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister().then((success) => {
          if (success) {
            console.log('Service worker unregistered - images will use browser cache');
          }
        });
      })
      .catch((error) => {
        console.error('Error unregistering service worker:', error);
      });
    
    // Also remove all service workers
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister();
      }
    });
  }
}

